import { render, staticRenderFns } from "./ClaimBalanceSummary.vue?vue&type=template&id=325542e9&scoped=true&"
import script from "./ClaimBalanceSummary.vue?vue&type=script&lang=js&"
export * from "./ClaimBalanceSummary.vue?vue&type=script&lang=js&"
import style0 from "./ClaimBalanceSummary.vue?vue&type=style&index=0&id=325542e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325542e9",
  null
  
)

export default component.exports